import { render, staticRenderFns } from "./SalesTypeIndicator.vue?vue&type=template&id=151ebb96&scoped=true"
import script from "./SalesTypeIndicator.vue?vue&type=script&lang=js"
export * from "./SalesTypeIndicator.vue?vue&type=script&lang=js"
import style0 from "./SalesTypeIndicator.vue?vue&type=style&index=0&id=151ebb96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151ebb96",
  null
  
)

export default component.exports